export default {
    computed: {
        background() {
            return this.getImage(this.$store.state.loginPage.background);
        },
        logo() {
            return this.getImage(this.$store.state.loginPage.logo);
        },
        getBackgroundCss() {
            if (!this.background) {
                return '';
            }
            return {backgroundImage: 'url(' + this.background + ')'};
        }
    },
    methods: {
        getImage(base64) {
            if (!base64) {
                return null;
            }
            return "data:image;base64," + base64.replace(/(\r\n|\n|\r)/gm, "");
        }
    },
    watch: {
        /**
         * because of loading logo and background like base64 images from backend so we show loader until this data will be loaded
         * we watch logo not background because background can be null but logo always must exist
         */
        logo() {
            this.$store.commit('loginPage/finishLoading')
        }
    }
}
